import { useEffect } from 'react';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const usePushNotifications = () => {
    const { user, token } = useAuth();

    useEffect(() => {
        // Only run on native platforms (iOS/Android) and when user is logged in
        if (!Capacitor.isNativePlatform() || !token) {
            return;
        }

        const registerPush = async () => {
            try {
                // 1. Check & Request Permissions (Firebase Plugin handles both)
                let permStatus = await FirebaseMessaging.checkPermissions();

                if (permStatus.receive === 'prompt') {
                    permStatus = await FirebaseMessaging.requestPermissions();
                }

                if (permStatus.receive !== 'granted') {
                    console.warn('Push notification permission denied');
                    return;
                }

                // 2. Get Token (This returns an FCM token on BOTH iOS and Android)
                // On iOS, this internally handles the APNs -> FCM mapping.
                const { token: fcmToken } = await FirebaseMessaging.getToken();

                console.log('FCM Token Received:', fcmToken);

                // 3. Send to Backend
                try {
                    const deviceType = Capacitor.getPlatform(); // 'ios' or 'android'
                    await authAPI.registerDevice(fcmToken, deviceType);
                    // Save locally
                    localStorage.setItem('fcm_token', fcmToken);
                } catch (err) {
                    console.error('Backend Push Registration Failed:', err);
                }

                // 4. Setup Listeners
                await FirebaseMessaging.removeAllListeners();

                FirebaseMessaging.addListener('notificationReceived', (event) => {
                    console.log('Push Received:', event);
                    window.dispatchEvent(new CustomEvent('data-refresh'));
                });

                FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
                    console.log('Push Action:', event);
                    // Add deep link logic here if needed
                });

            } catch (e) {
                console.error('Push Initialization Failed:', e);
            }
        };

        registerPush();

        return () => {
            FirebaseMessaging.removeAllListeners();
        };

    }, [token]);
};

export default usePushNotifications;
